var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_29846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.1523C14.4628 18.1523 18.5 14.1151 18.5 9.15234C18.5 4.18958 14.4628 0.152343 9.5 0.152343C4.53724 0.152343 0.500001 4.18958 0.500001 9.15234C0.5 14.1151 4.53724 18.1523 9.5 18.1523ZM6.71974 8.62208L10.4698 4.8721C10.616 4.72586 10.808 4.65234 11 4.65234C11.192 4.65234 11.384 4.72586 11.5303 4.8721C11.8235 5.16534 11.8235 5.63935 11.5303 5.93259L8.31049 9.15234L11.5302 12.3721C11.8235 12.6653 11.8235 13.1393 11.5302 13.4326C11.237 13.7258 10.763 13.7258 10.4698 13.4326L6.71974 9.68257C6.4265 9.38933 6.4265 8.91535 6.71974 8.62208Z",
    fill: "#046C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_29846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(18.5 18.1523) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleLeft);
export default __webpack_public_path__ + "static/media/icon-circle-left.a77eae833423b9145ffc65515dda5cd6.svg";
export { ForwardRef as ReactComponent };